import { useOrgIntegrations } from "@/api/integrations";
import { useMemo } from "react";

/**
 * Resolves the org's Google Calendar integration connection. Matches both
 * platform casings the backend may report (google_calendar / google-calendar).
 */
export function useGoogleCalendarConnection() {
  const { data: integrations, isLoading } = useOrgIntegrations();

  const result = useMemo(() => {
    if (!integrations) {
      return { connectionId: undefined, isLoading: true, hasConnection: false };
    }
    const conn = integrations.find(
      (i) =>
        (i.platform === "google_calendar" ||
          i.platform === "google-calendar") &&
        i.connected,
    );
    return {
      connectionId: conn?.integration_connection_id,
      isLoading: false,
      hasConnection: !!conn,
    };
  }, [integrations]);

  return { ...result, isLoading: isLoading || result.isLoading };
}
